import { Tooltip } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './SutochnoTooltip.css';

interface ISutochnoTooltipProps {
  enabled: boolean;
  children: React.ReactElement;
}

export const SutochnoTooltip = ({ enabled, children }: ISutochnoTooltipProps) => {
  if (!enabled) {
    return children;
  }

  return (
    <Tooltip
      arrow
      placement="bottom-end"
      title={
        <span className={styles['content']}>
          Поиск и&nbsp;бронирование жилья будут осуществляться в&nbsp;новом разделе посуточной аренды сайта Циан
        </span>
      }
    >
      {children}
    </Tooltip>
  );
};
